export const PAGINATION_SELECT_PAGE_SIZE = 50
export const tNamespace = "common"
